import type { StaticEntityType } from "@config";
import { Set } from "@library-containers/layers";
import { SimpleView } from "./Simple.view";

export const SimpleLibrary = ({ entity }: { entity: StaticEntityType }) => {
  const { children, settings, id } = entity;
  return (
    <SimpleView entity={entity}>
      {children.map((child) => (
        <Set
          key={child.id}
          entity={{
            ...child,
            layers: {
              ...(entity.layers || {}),
              combo: { settings, index: 0, id },
            },
          }}
        />
      ))}
    </SimpleView>
  );
};
